import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@mui/material";
import useTranslation from "../../../shared/hooks/useTranslation";
import colors from "../../../shared/themes/colors";

interface RejectOfferDialogProps {
  open: boolean;
  offerNumber: string;
  onConfirm: (reason?: string) => void;
  onClose: () => void;
}

const RejectOfferDialog = ({
  open,
  offerNumber,
  onConfirm,
  onClose,
}: RejectOfferDialogProps) => {
  const { translate } = useTranslation(["servicing", "common"]);
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirm(reason.trim() || undefined);
    setReason("");
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle className="text-18-bold" sx={{ color: colors.secondary.gray15 }}>
        {translate("servicing:rejectOfferTitle")}
      </DialogTitle>
      <DialogContent>
        <Box className="text-14-regular" sx={{ color: colors.secondary.gray40, mb: 2 }}>
          {translate("servicing:rejectOfferText", { number: offerNumber })}
        </Box>
        <TextField
          fullWidth
          multiline
          rows={3}
          label={translate("servicing:rejectionReason")}
          placeholder={translate("servicing:rejectionReasonPlaceholder")}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          variant="outlined"
          size="small"
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          {translate("common:common.no")}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          sx={{
            backgroundColor: colors.primary.red,
            "&:hover": { backgroundColor: `${colors.primary.red}CC` },
          }}
        >
          {translate("servicing:yesReject")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectOfferDialog;
